import ForgotPasswordFeature from '../../components/features/auth/ForgotPassword';

const ForgotPassword = () => (
  <div className="flex flex-col gap-10 h-full">
    <ForgotPasswordFeature />
  </div>
);

export default ForgotPassword;
